module.exports = __webpack_public_path__ + "img/success.71869cbc.png";